import { getDataFromResponceError } from '../../shared/utils';

const CONCURRENT_IMPORT_SUBCODE = 'ProductsBatchImportIsRunningApiError';

export default function isConcurrentImportError(error) {
  const status = error?.response?.status;
  const subcode = getDataFromResponceError(error, 'subcode');
  return status === 409 && subcode === CONCURRENT_IMPORT_SUBCODE;
}
